import React, { Component, Fragment } from 'react';
import ApiService from "../../../ApiService";
import SchoolPageTitle from '../../../SchoolPageTitle';
import AdminSchoolMenu from '../../../AdminSchoolMenu';
import {MisDataServiceTypes} from "../../../../models/SchoolMailroomConfigDto";
import ReactJson from "react-json-view";

import AceEditor from "react-ace";
import "ace-builds/webpack-resolver";
import "ace-builds/src-noconflict/mode-xml";
import "ace-builds/src-noconflict/theme-github";


interface MisFetchRunFilePageProps {
    apiService: ApiService;

    tenantId: string;
    schoolCode: string;
    dataServiceType: MisDataServiceTypes;
    id: string;
    name: string;
}

interface MisFetchRunFilePageState {
    fileContents?: string;
}

export default class MisFetchRunFilePage extends Component<MisFetchRunFilePageProps, MisFetchRunFilePageState> {
    static displayName = MisFetchRunFilePage.name;

    constructor(props: MisFetchRunFilePageProps) {
        super(props);

        this.state = {
        }
    }

    async componentDidMount() {
  
        await this.loadFiles();
    }

    async componentDidUpdate(prevProps: Readonly<MisFetchRunFilePageProps>, prevState: any): Promise<void> {

    }
    
    private loadFiles = async () => {
        
        this.setState({
            fileContents:undefined
        });

        const fileContents = await this.props.apiService.getSalamanderHostRunFileContents(this.props.tenantId, this.props.schoolCode, this.props.dataServiceType,this.props.id, this.props.name);

        this.setState({
            fileContents
        });
    }

    render() {
        
        let editor: JSX.Element | undefined = undefined;
        
        if(this.state.fileContents !== undefined)
        {
            switch (typeof(this.state.fileContents))
            {
                case "string":
                    editor = (
                        <AceEditor
                            mode="xml"
                            theme="github"
                            value={this.state.fileContents === undefined ? "Loading" : this.state.fileContents}
                            name="xmlViewer"
                            width="100%"
                            height="100%"
                            wrapEnabled={true}
                            readOnly={true}
                        />
                    );
                    break;
                case "object":
                    editor = (
                        <ReactJson src={this.state.fileContents} displayDataTypes={true} displayObjectSize={true}  theme="rjv-default"/>
                    );
                    break;
                default:
                    break;
            }
        }
        
        console.log(this.state.fileContents);
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Hosted Run File" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <div className={"card flex-item--flex-1"}>
                    <div className={"card__header"}>
                        <div className={"card__title"}>{this.props.name}</div>
                    </div>
                    {editor}
                    
                </div>
            </Fragment>
        );
    }
}